module.exports = __webpack_public_path__ + "img/newJD-eye-icon.f1d2ebda.svg";